import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { useState, useEffect } from "react";
import { FormTitle, Text, SelectField } from "ui-components/Form";
//import RangeInputGroup from "./ColourRange";
import { getKPIProductivityRangeList,getKPIUserRangeList } from "services/data.kpi.service";
import { getCustomerOptions } from "services/data.internal.service";
import { useCustomerValue } from "providers/CustomerContext";
import { useQuery } from "@tanstack/react-query";
import { SelectFields } from "ui-components/Form";
import { Controller } from "react-hook-form";

// const productivityrangeoption = {
//   type: ["Carton", "Flyer"],
// };

// const userrangeoption = {
//   type: ["Carton", "Flyer"],
// };

// const option = {
//   type: ["Carton", "Flyer"],
// };



function KPITeamInfo({ formRender, control, errors, mode = "ADD" }) {
  const [productivityOptions, setProductivityOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [status, setStatus] = useState("Active");
  const active = status === "Active" ? true : false;
  const { customerCode, customerOpt } = useCustomerValue();
  //const [customers, setCustomers] = useState([]);

  const [customerOptions, setCustomerOptions] = useState([]);
  // useEffect(() => {
  //   getKPIProductivityRangeList({ active }).then((res) => {
  //     // You may need to map response to a suitable format like:
  //     // [{ label: 'Carton', value: 'Carton' }]
  //     setProductivityOptions(res?.data || []))
  //     .catch((err) => {
  //       console.error("Failed to fetch productivity range:", err);
  //   });

  //   getKPIUserRangeList({ active }).then((res) => {
  //     setUserOptions(res?.data || []);
  //   });
  // }, []);

  // useEffect(() => {
  //   getKPIProductivityRangeList({ active })
  //     .then((res) => setProductivityOptions(res?.data || []))
  //     .catch((err) => {
  //       console.error("Failed to fetch productivity range:", err);
  //     });
  
  //   getKPIUserRangeList({ active })
  //     .then((res) => setUserOptions(res?.data || []))
  //     .catch((err) => {
  //       console.error("Failed to fetch user range:", err);
  //     });
  // }, []);

  useEffect(() => {
    getKPIProductivityRangeList({ active })
      .then((res) => {
        //console.log("Productivity Range API Response:", res);
        const list = res?.data?.data || [];
        const options = list.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setProductivityOptions(options);
      })
      .catch((err) => {
        console.error("Error fetching productivity range:", err);
        setProductivityOptions([]);
      });
  
    getKPIUserRangeList({ active })
      .then((res) => {
        //console.log("User Range API Response:", res);
        const list = res?.data?.data || [];
        const options = list.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setUserOptions(options);
      })
      .catch((err) => {
        console.error("Error fetching user range:", err);
        setUserOptions([]);
      });
  }, []);

  useQuery({
      queryKey: ["customer-options", {customerCode}],
      queryFn: () => getCustomerOptions(),
      onSuccess: (data) => {
        const activeCust = customerOpt.filter(x => data.data.some(y => y === x));
        setCustomerOptions(activeCust);
        //setCustomers([customerCode])
      },
      onError: () => { },
    })
    const [customers, setCustomers] = useState([]);

  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit KPI Team" : "KPI Team Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { editable, ...data } = property;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(mode === "EDIT" && editable === false && { disabled: true }),
              };

              let renderField;
              switch (fieldProps.type) {
                case "text":
                  if (fieldProps.name !== "range")
                    renderField = <Text field={fieldProps} />;
                  else 
                  renderField = <Text field={fieldProps} />;
                    // renderField = (
                    // <RangeInputGroup {...fieldProps} />)
                  break;
                case "select":
                  if (fieldProps.name == "productivity")
                  renderField = <SelectField field={fieldProps} options={productivityOptions} />;
                  else if (fieldProps.name == "user")
                    renderField = <SelectField field={fieldProps} options={userOptions} />;
                  else if (fieldProps.name == "customerCode")
                    // renderField = <SelectFields field={{name: "", label: "Zone/Location",value:fieldProps
                    //   ,multiple: true }} options={customerOptions}  />;

                //       renderField =
                //       <SelectFields
                //   field={{
                //     name: "",
                //     label: "Customers",
                //     value: customers,
                //     errors: {},
                //     multiple: true,
                //   }}
                //   options={customerOptions}
                //   onChange={(e, v) => setCustomers(v)}
                // />
                renderField = (
                  <Controller
  control={control}
  name="customerCode"
  rules={{ required: "Customer is required" }} // ✅ Make it required
  render={({ field, fieldState: { error } }) => (
    <SelectFields
      field={{
        ...field,
        label: (
          <span>
            <span style={{ color: 'red' }}> Customers *</span> {/* ✅ Red asterisk */}
          </span>
        ),
        value: field.value ?? [],
        multiple: true,
        errors,
        error: !!error, // ✅ Trigger red styling
        helperText: error?.message, // ✅ Show error message
      }}
      options={customerOptions}
      onChange={(e, value) => field.onChange(value)}
    />
  )}
/>
                  // <Controller
                  //   control={control}
                  //   name="customerCode"
                  //   render={({ field }) => (
                  //     <SelectFields
                  //       field={{ ...field, label: "Customers",value: field.value ?? [], multiple: true, errors }}
                  //       options={customerOptions}
                  //       onChange={(e, value) => field.onChange(value)} 
                  //     />
                  //   )}
                  // />
                );
              //     <SelectFields
              // field={{ name: "", label: "Zone/Location", value: criteriaZoneLocationAisle2, errors: {}, multiple: true }}
              // options={["Zone", "Location"]}
              // onChange={(e, v) => setCriteriaZoneLocationAisle2(v)}
            ///>
                  break;
              }
 
              return (
                <Grid item xs={12} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default KPITeamInfo;
